module.exports = __webpack_public_path__ + "static/img/guide-28.956a9b32.png";